import { useEffect, useState } from 'react';
export const useRequestUrl = () => {
    const [requestUrl, setRequestUrl] = useState('');
    useEffect(() => {
        if (!requestUrl) {
            setRequestUrl(window.location.href);
        }
    }, [requestUrl]);
    return requestUrl;
};
//# sourceMappingURL=use-request-url.js.map